<script lang="ts" setup>
  import { useThemeConfig } from '@core/composable/useThemeConfig';

  // Components
  import SupportFab from '@/components/support/SupportFab.vue';
  import Footer from '@/layouts/components/Footer.vue';
  import HorizontalUserProfile from '@/layouts/components/HorizontalUserProfile.vue';
  import NavbarThemeSwitcher from '@/layouts/components/NavbarThemeSwitcher.vue';

  // @layouts plugin
  import { useVerticalNavByRole } from '@/navigation/vertical';
  import { useAuthStore } from '@/stores/agency/auth';
  import { VerticalNavLayout } from '@layouts';

  // This component renders two roots (the layout + SupportFab), so Vue cannot auto-inherit the
  // verticalNavAttrs that default.vue passes down — they have to be forwarded by hand. Without this
  // they are dropped, taking the semi-dark nav wrapper (VThemeProvider) with them.
  defineOptions({ inheritAttrs: false });

  const authStore = useAuthStore();
  const { appRouteTransition, isLessThanOverlayNavBreakpoint } = useThemeConfig();
  const { width: windowWidth } = useWindowSize();
  const role = computed(() => authStore.getCurrentTenantRole || '');
  const navItems = computed(() => useVerticalNavByRole(role.value));
</script>

<template>
  <VerticalNavLayout v-bind="$attrs" :nav-items="navItems">
    <!-- 👉 navbar -->
    <template #navbar="{ toggleVerticalOverlayNavActive }">
      <div class="d-flex h-100 align-center">
        <IconBtn
          v-if="isLessThanOverlayNavBreakpoint(windowWidth)"
          id="vertical-nav-toggle-btn"
          class="ms-n3"
          @click="toggleVerticalOverlayNavActive(true)"
        >
          <VIcon size="26" icon="tabler-menu-2" />
        </IconBtn>

        <VSpacer />

        <NavbarThemeSwitcher class="me-2" />
        <ChangeLog class="me-2" />
        <Notifications class="me-5" />
        <HorizontalUserProfile :is-minimal="['Point of Contact'].includes(role)" />
      </div>
    </template>

    <!-- 👉 Pages -->
    <RouterView v-slot="{ Component }">
      <Transition :name="appRouteTransition" mode="out-in">
        <Component :is="Component" />
      </Transition>
    </RouterView>

    <!-- 👉 Footer -->
    <template #footer>
      <Footer />
    </template>

    <!-- 👉 Customizer -->
    <!-- <TheCustomizer /> -->
  </VerticalNavLayout>

  <SupportFab />
</template>
